<div class="full-container pt-5 lg:pr-5 lg:pl-5 w-full pb-3" *ngIf="aupDetails() as details">
  <section
    class="flex justify-content-between mb-2 align-items-center px-3 lg:px-0 aup-header flex-column lg:flex-row lg:mb-5"
  >
    <div>
      <h1 class="lg:text-2xl text-xl mx-0 my-0 title flex align-items-center">
        <p-button icon="pi pi-arrow-left" [rounded]="true" [text]="true" severity="secondary" (click)="goBack()" />{{
          details.name
        }}
        {{ details.dateFrom }} - {{ details.dateTo }} (UTC)
      </h1>
    </div>
    <div class="py-2">
      <rqa-toggle-button
        [label]="'aup.visualizationDesignators' | translate"
        [className]="'aup'"
        [checked]="visualizationChecked"
        (changed)="onToggleVisualization($event)"
      ></rqa-toggle-button>
    </div>
  </section>
  <section class="overflow-x-auto max-w-screen">
    <p-table
      #dt
      [value]="reservations()"
      [styleClass]="'pansa-table'"
      selectionMode="single"
      [scrollHeight]="tableScrollHeight"
      sortMode="single"
      [breakpoint]="'960px'"
      (onRowSelect)="onRowSelect($event)"
      (onRowUnselect)="onRowUnselect($event)"
      rqaTableKeyboardNavigation
      [tabindex]="0"
      [scrollable]="true"
      (sortFunction)="customSortFunction($event)"
      [customSort]="true"
    >
      <ng-template pTemplate="caption">
        @if (!visualizationChecked) {
          <form
            [formGroup]="filtersForm"
            class="filters-form align-items-center justify-content-between justify-content-between flex w-full"
          >
            <div class="filters-container flex-column flex w-11 gap-4">
              <div class="w-full flex pt-2">
                <p-floatLabel class="w-full">
                  <p-treeSelect
                    [filter]="true"
                    inputId="designator"
                    [options]="designatorOptionsTree"
                    formControlName="designator"
                    [selectionMode]="'checkbox'"
                    [propagateSelectionDown]="true"
                    [propagateSelectionUp]="true"
                    panelStyleClass="w-15rem"
                    display="chip"
                    [appendTo]="'body'"
                    containerStyleClass="w-full flex"
                    [showClear]="true"
                  >
                    <ng-template pTemplate="value" let-selectedNodes>
                      <div class="flex flex-wrap gap-2">
                        <div *ngFor="let node of selectedNodes">
                          <p-chip
                            [styleClass]="'tree-chip'"
                            [label]="node.label"
                            [removable]="true"
                            (onRemove)="removeDesignatorChip(node, $event)"
                          />
                        </div>
                      </div>
                    </ng-template>
                  </p-treeSelect>
                  <label for="designator">{{ 'aup.table.designator' | translate }}</label>
                </p-floatLabel>
              </div>
              <div class="w-full flex">
                <p-floatLabel class="w-full">
                  <p-multiSelect
                    #multiSelectResponsibleUnit
                    inputId="responsibleUnit"
                    [options]="unitOptions"
                    formControlName="responsibleUnit"
                    display="chip"
                    styleClass="w-full"
                    [appendTo]="'body'"
                    [showClear]="true"
                    [maxSelectedLabels]="filtersForm.get('responsibleUnit')?.length"
                    panelStyleClass="w-15rem"
                  />
                  <label for="responsibleUnit">{{ 'aup.table.responsibleUnit' | translate }}</label>
                </p-floatLabel>
              </div>

              <div class="flex w-full gap-2 flex-column lg:flex-row">
                <div
                  formGroupName="timeRange"
                  class="flex flex-wrap w-full lg:w-4 mb-3 lg:mb-0"
                  [ngClass]="{
                    'lg:w-4': details.name === 'UUP',
                    'lg:w-6': details.name === 'AUP',
                    'border-red-500 border-bottom-2 pb-1': filtersForm.get('timeRange').invalid
                  }"
                >
                  <div class="flex flex-nowrap gap-2 w-full">
                    <p-floatLabel class="w-6">
                      <p-inputMask
                        id="from"
                        mask="99:99"
                        formControlName="from"
                        [slotChar]="'_'"
                        rqaTimeControl
                        [ngClass]="{ 'ng-invalid': filtersForm.get('timeRange').invalid }"
                      />
                      <label for="from">{{ 'aup.table.from' | translate }}</label>
                    </p-floatLabel>
                    <p-floatLabel class="w-6">
                      <p-inputMask
                        id="until"
                        mask="99:99"
                        formControlName="until"
                        [slotChar]="'_'"
                        rqaTimeControl
                        [ngClass]="{ 'ng-invalid': filtersForm.get('timeRange').invalid }"
                      />
                      <label for="until">{{ 'aup.table.until' | translate }}</label>
                    </p-floatLabel>
                  </div>
                  <div>
                    <rqa-validator [formGroup]="filtersForm.get('timeRange')"></rqa-validator>
                  </div>
                </div>

                <div
                  formGroupName="altitudeRange"
                  class="flex flex-wrap w-full lg:w-4 mb-3 lg:mb-0"
                  [ngClass]="{
                    'lg:w-4': details.name === 'UUP',
                    'lg:w-6': details.name === 'AUP',
                    'border-red-500 border-bottom-2 pb-1': filtersForm.get('altitudeRange').invalid
                  }"
                >
                  <div class="flex flex-nowrap gap-2 w-full">
                    <p-floatLabel class="w-6">
                      <p-autoComplete
                        appendTo="body"
                        formControlName="flMin"
                        [suggestions]="filteredAltitudes"
                        (completeMethod)="searchAltitude($event, 'flMin')"
                        [forceSelection]="true"
                        [completeOnFocus]="true"
                        [ngClass]="{ 'ng-invalid ng-dirty': filtersForm.get('altitudeRange').invalid }"
                      ></p-autoComplete>
                      <label for="flMin">{{ 'aup.table.flMin' | translate }}</label>
                    </p-floatLabel>

                    <p-floatLabel class="w-6">
                      <p-autoComplete
                        appendTo="body"
                        formControlName="flMax"
                        [suggestions]="filteredAltitudes"
                        (completeMethod)="searchAltitude($event, 'flMax')"
                        [forceSelection]="true"
                        [completeOnFocus]="true"
                        [ngClass]="{ 'ng-invalid ng-dirty': filtersForm.get('altitudeRange').invalid }"
                      ></p-autoComplete>
                      <label for="flMax">{{ 'aup.table.flMax' | translate }}</label>
                    </p-floatLabel>
                  </div>
                  <div>
                    <rqa-validator [formGroup]="filtersForm.get('altitudeRange')"></rqa-validator>
                  </div>
                </div>

                <div class="flex flex-wrap w-full mb-3 lg:mb-0 flex-column lg:flex-row">
                  <p-floatLabel
                    [ngClass]="{ 'w-full': !(details.name === 'UUP'), 'w-full lg:w-7': details.name === 'UUP' }"
                  >
                    <input type="text" pInputText formControlName="remarks" />
                    <label for="remarks">{{ 'aup.table.activityType' | translate }}</label>
                  </p-floatLabel>

                  <p-floatLabel class="w-full lg:w-5 mt-5 lg:mt-0" *ngIf="details.name === 'UUP'">
                    <p-dropdown
                      [options]="statusOptions"
                      formControlName="status"
                      inputId="status"
                      optionLabel="name"
                      (onChange)="onStatusChange($event)"
                      [styleClass]="'w-full'"
                    />
                    <label for="status">{{ 'aup.table.status' | translate }}</label>
                  </p-floatLabel>
                </div>
              </div>
            </div>

            <div class="flex w-1 text-center">
              <p-button
                icon="pi pi-filter-slash"
                severity="danger"
                [rounded]="true"
                [text]="true"
                (click)="clearFilters()"
                class="w-full"
              />
            </div>
          </form>
        }
      </ng-template>
      <ng-template pTemplate="header">
        <tr class="text-xs">
          <th class="text-xs" pSortableColumn="designator">
            {{ 'aup.table.designator' | translate }} <p-sortIcon field="designator"></p-sortIcon>
          </th>
          <th class="text-xs" pSortableColumn="flMin">
            {{ 'aup.table.flMin' | translate }} <p-sortIcon field="flMin"></p-sortIcon>
          </th>
          <th class="text-xs" pSortableColumn="flMax">
            {{ 'aup.table.flMax' | translate }} <p-sortIcon field="flMax"></p-sortIcon>
          </th>
          <th class="text-xs" pSortableColumn="from">
            {{ 'aup.table.from' | translate }} <p-sortIcon field="from"></p-sortIcon>
          </th>
          <th class="text-xs" pSortableColumn="until">
            {{ 'aup.table.until' | translate }} <p-sortIcon field="until"></p-sortIcon>
          </th>
          <th class="text-xs" pSortableColumn="responsibleUnit">
            {{ 'aup.table.responsibleUnit' | translate }} <p-sortIcon field="responsibleUnit"></p-sortIcon>
          </th>
          <th class="text-xs" pSortableColumn="remarks">
            {{ 'aup.table.activityType' | translate }} <p-sortIcon field="remarks"></p-sortIcon>
          </th>
          <th class="text-xs" pSortableColumn="status" *ngIf="details.name === 'UUP'">
            {{ 'aup.table.status' | translate }} <p-sortIcon field="status"></p-sortIcon>
          </th>
          <th class="p-0">
            <p-button
              icon="pi pi-sort-alt-slash"
              [rounded]="true"
              [text]="true"
              severity="danger"
              (click)="clearSort()"
            />
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr class="text-sm" [pSelectableRow]="item">
          <td>
            {{ item.designator }}
          </td>
          <td>
            {{ item.flMin }}
          </td>
          <td>
            {{ item.flMax }}
          </td>
          <td>
            {{ item.from }}
          </td>
          <td>
            {{ item.until }}
          </td>
          <td>
            {{ item.responsibleUnit }}
          </td>
          <td>
            {{ item.remarks }}
          </td>
          <td *ngIf="details.name === 'UUP'" class="py-1">
            <rqa-status-info [statusName]="item.status" class="flex" />
          </td>
          <td></td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <div class="p-2">
          {{ 'primeng.emptyFilterMessage' | translate }}
        </div>
      </ng-template>
    </p-table>
  </section>
  <section *ngIf="isGraphVisible">
    <rqa-designator-graph [data]="reservationsForChart" class="w-full"></rqa-designator-graph>
  </section>
</div>
